/* Banky Nieuw WP1.1: gedrag van de aankondigingsbalk en de zwevende kop (geladen door snippets/banky-header-float).
   1. <banky-balk> (snippets/banky-quiet-usp): op desktop wisselt het wisselvak rustig (8 s, zachte fade); tot 1199px
      staat er één regel die per 4 s wisselt en na drie rondes stilstaat op het eerste vak. Pauze bij hover, focus en
      een verborgen tabblad; niets beweegt bij prefers-reduced-motion. Vervangt de wissel van banky-usp-bar.
   2. Megamenu (details.banky-menu-disclosure, Halo's dropdown-disclosure met trigger click): op een apparaat met muis
      opent het paneel ook bij aanwijzen en sluit het 180 ms na verlaten (zoals Banky Scratch), klikken en toetsenbord
      blijven werken via Halo (Enter, Escape, focus weg). Een open paneel sluit als je verder scrolt. Een muisklik op de
      knop van een paneel dat al open is (eerst aanwijzen, dan klikken, wat bijna iedereen doet) sluit het niet meer;
      sluiten gaat met de muis door weg te gaan, met Escape of als de focus weggaat. Enter op het toetsenbord toggelt.
      Wisselen tussen panelen gaat in één keer (nieuw paneel direct in beeld, geen fade), anders knippert het in Safari;
      bij klikken en tikken blijft het oude paneel open tot de klik, en de strook tussen knop en paneel hoort bij het menu.
      Geert 04-10-2026, ronde 2 ("voor web wil ik dat je inspiratie haalt over de animatie van hoe het menu opent en wisselt tussen andere
      menu's. overloopt en opent"): openen na 120 ms aanwijzen, wisselen na 40 ms, sluiten 250 ms na weggaan; uitrollen bij openen, overlopen
      van hoogte en inhoud bij wisselen, oprollen bij sluiten, een glijdende pil en pijltjestoetsen (details bij blok 2 hieronder).
   2c. Uitgelicht product dat meewisselt met de aangewezen link (Geert 04-10-2026, ronde 2), zie blok 2c.
   2d. Klikbare categorienamen (Geert 05-10-2026, ronde 7: "deze categorien moeten ook klikbaar zijn op web trouwens"): de naam is een link
      naar de collectie, het pijltje de knop van het megamenu (snippets/banky-menu-categorie.liquid). Het menu-item (li) als geheel opent
      bij aanwijzen; een muisklik op de naam volgt de link, op een aanraakscherm opent de eerste tik het menu en volgt de tweede tik op
      de naam de link; zie blok 2 en 2d.
   5. Mobiele kop (Geert 04-10-2026, ronde 2): tabvolgorde, naam van de menuknop en zoeken of winkelwagen met open lade, zie blok 5.
   2b. Een open menu is een eigen beeld (beloftematrix R3, PRINCIPES 5); boven het megamenu staat de balk, de mobiele lade bedekt hem (03-10):
      zolang het open is, staat de balk stil op een vak of bericht dat de voet van dat menu niet herhaalt (data-belofte
      op balk en menuvoet) en daarna wisselt hij gewoon verder.
      Geert 04-10-2026 ("er is voor de 5e keer een probleem met de aankondigingsbalk in het menu. het blijft weer hangen als je het menu
      opent"): tot en met 1199px (één regel; tot 699px staat hij sinds 04-10 met open lade bovenaan in beeld) staat de balk niet meer
      stil. Hij wisselt door in hetzelfde ritme van 4 s (de timer loopt door bij openen en sluiten, dus geen sprong en geen dubbele
      snelheid) en slaat vakken en berichten over die de voet van het open menu herhaalt. Wisselt hij bij het openen meteen (dat vak
      stond in de menuvoet), dan begint de 4 s daar opnieuw. Zolang de lade open is, pauzeert aanwijzen hem niet: hij schuift dan onder
      de plek van de tik op de menuknop en Safari geeft hem :hover. Openen en sluiten zijn elk een nieuw beeld: daarna weer hooguit
      drie rondes, ook als de balk op de pagina al stilstond. Vanaf 1200px (megamenu) blijft het zoals hierboven.
      Wisselt de balk daarvoor van vak of bericht, dan met de gewone fade (Geert 02-10, mobiel menu: geen harde tekstsprong bij het tikken).
   3. Winkelwagenteller: korte puls (600 ms) bij cart:change, niet bij prefers-reduced-motion.
   4. Kop weg en terug bij scrollen: Halo's store-header (attribuut hide-on-scroll) houdt zijn scrollluisteraar, maar het wisselen en de
      drempels doet blok 4 hieronder (klasse is-banky-weg op store-header), de beweging de CSS in snippets/banky-header-float. */
(() => {
  const rust = matchMedia('(prefers-reduced-motion: reduce)');

  if (!customElements.get('banky-balk')) customElements.define('banky-balk', class extends HTMLElement {
    connectedCallback() {
      if (this._klaar) return;
      this._klaar = true;
      this.vakken = [...this.querySelectorAll(':scope > .banky-balk__inner > .banky-balk__vak')];
      this.berichten = [...this.querySelectorAll('[data-balk-bericht]')];
      this.bericht = Math.max(0, this.berichten.findIndex(b => !b.hidden));
      this.vak = 0;
      this.rondes = 0;
      this.vanaf = 0;
      this.stil = false;
      this.smal = matchMedia('(max-width: 1199px)');
      this._pauze = () => this.stop();
      // Aanwijzen met open lade pauzeert niet (Geert 04-10-2026, 2b); weg met de muis start alleen een balk die stilstaat.
      this._wijs = () => { if (!this.lade) this.stop(); };
      this._weg = () => { if (!this.timer) this.plan(); };
      this._verder = () => this.plan();
      this._uit = () => queueMicrotask(() => { if (this.isConnected) this.plan(); });
      this._breedte = () => { this.toon(); this.plan(); };
      this.addEventListener('mouseenter', this._wijs);
      this.addEventListener('mouseleave', this._weg);
      this.addEventListener('focusin', this._pauze);
      this.addEventListener('focusout', this._uit);
      document.addEventListener('visibilitychange', this._verder);
      this.smal.addEventListener('change', this._breedte);
      rust.addEventListener('change', this._verder);
      this.toon();
      this.setAttribute('data-ready', '');
      this.plan();
    }
    get wisselt() { return this.smal.matches && this.vakken.length > 1; }
    get lade() { return !!this.menu && this.wisselt; }
    toon() {
      const aan = this.wisselt;
      this.classList.toggle('banky-balk--rij', aan);
      this.vakken.forEach((v, i) => v.classList.toggle('is-active', !aan || i === this.vak));
    }
    fade(el) {
      if (!rust.matches && el && el.animate) el.animate([{opacity: 0}, {opacity: 1}], {duration: 280, easing: 'ease-out'});
    }
    // Met open menu (2b) slaan bericht en vak over wat de menuvoet al toont.
    volgendBericht(fade) {
      if (this.berichten.length < 2) return;
      let i = this.bericht;
      for (let n = this.berichten.length; n--;) { i = (i + 1) % this.berichten.length; if (!this.menu || !this.menu.has(this.berichten[i].dataset.belofte)) break; }
      if (i === this.bericht) return;
      this.zetBericht(i);
      if (fade) this.fade(this.berichten[i]);
    }
    stap() {
      if (!this.wisselt) { this.volgendBericht(true); return; }
      for (let n = this.vakken.length; n--;) {
        this.vak = (this.vak + 1) % this.vakken.length;
        if (this.vak === 0 && ++this.rondes - this.vanaf >= 3) this.stil = true;
        if (this.rondes > 0 && this.vakken[this.vak].hasAttribute('data-balk-wissel')) this.volgendBericht(false);
        if (this.stil || !this.menu || !this.menu.has(this.belofteVan(this.vakken[this.vak]))) break;
      }
      this.toon();
      this.fade(this.vakken[this.vak]);
      if (this.stil) this.stop();
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    zetBericht(i) {
      if (i === this.bericht || !this.berichten[i]) return;
      this.berichten[this.bericht].hidden = true;
      this.bericht = i;
      this.berichten[i].hidden = false;
    }
    // Belofte die een vak nu toont: het wisselvak toont die van zijn zichtbare bericht.
    belofteVan(vak) { return (vak.hasAttribute('data-balk-wissel') ? this.berichten[this.bericht]?.dataset.belofte : vak.dataset.belofte) || ''; }
    // Tot en met 1199px loopt de timer door (Geert 04-10-2026, 2b); een nieuw beeld krijgt weer drie rondes. Wisselde de balk bij het
    // openen zichtbaar, dan begint de 4 s opnieuw, anders kan de timer meteen daarna nog eens wisselen.
    nieuwBeeld(opnieuw) { this.stil = false; this.vanaf = this.rondes; if (opnieuw || !this.timer) this.plan(); }
    menuOpen(beloftes) {
      // Geert 04-10-2026, ronde 3 def ("op die plek gaan we nu de sterkste usp van het betreffende menu plaatsen"; toets: bij het wisselen van
      // paneel stond de vervanger in de balk ongeveer 100 ms tegelijk met de USP van het vorige paneel, die nog 160 ms uitfadet): een vervanger
      // is bij voorkeur ook vrij ten opzichte van de vorige set, en anders alleen ten opzichte van de nieuwe.
      const vorige = this.menu || new Set();
      this.menu = beloftes;
      if (!this.wisselt) this.stop();
      const vrij = el => !beloftes.has(el?.dataset.belofte || '');
      const heelVrij = el => vrij(el) && !vorige.has(el?.dataset.belofte || '');
      const vakVoor = this.vakken[this.vak], berichtVoor = this.bericht;
      // Geert 02-10 (menu schokkerig): boven het megamenu blijft de balk in beeld, dus een wissel hier was een harde tekstsprong op het moment
      // van tikken; nu met dezelfde fade als het gewone wisselen. De mobiele lade bedekt de balk sinds 03-10.
      if (this.berichten.length && !vrij(this.berichten[this.bericht])) { let i = this.berichten.findIndex(heelVrij); if (i < 0) i = this.berichten.findIndex(vrij); if (i >= 0) { this.zetBericht(i); this.fade(this.berichten[i]); } }
      if (this.wisselt && beloftes.has(this.belofteVan(this.vakken[this.vak]))) {
        let i = this.vakken.findIndex(v => !beloftes.has(this.belofteVan(v)) && !vorige.has(this.belofteVan(v)));
        if (i < 0) i = this.vakken.findIndex(v => !beloftes.has(this.belofteVan(v)));
        if (i >= 0) { this.vak = i; this.toon(); this.fade(this.vakken[i]); }
      }
      if (this.wisselt) this.nieuwBeeld(this.vakken[this.vak] !== vakVoor || (this.bericht !== berichtVoor && this.vakken[this.vak].hasAttribute('data-balk-wissel')));
    }
    menuDicht() {
      if (!this.menu) return;
      this.menu = null;
      if (this.wisselt) this.nieuwBeeld(); else this.plan();
    }
    plan() {
      this.stop();
      if (this.menu && !this.wisselt) return;
      if (this.dataset.autoplay !== 'true' || rust.matches || document.hidden || (!this.lade && this.matches(':hover')) || this.contains(document.activeElement)) return;
      if (this.wisselt ? this.stil : this.berichten.length < 2) return;
      this.timer = setInterval(() => this.stap(), this.wisselt ? 4000 : 8000);
    }
    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this._verder);
      this.smal.removeEventListener('change', this._breedte);
      rust.removeEventListener('change', this._verder);
    }
  });

  const muis = matchMedia('(hover: hover) and (pointer: fine)');
  // Halo sluit een open paneel zodra de focus erbuiten komt; drukOp is de menuknop die nu wordt ingedrukt (muis of vinger).
  let drukOp = null;
  const druk = e => { drukOp = (e.button === 0 && e.target.closest?.('details.banky-menu-disclosure > summary, li.banky-nav-item > a.banky-nav-naam')) || null; };
  addEventListener('pointerdown', druk, true);
  addEventListener('mousedown', druk, true);
  addEventListener('click', () => { drukOp = null; }, true);
  addEventListener('keydown', () => { drukOp = null; }, true);

  // Geert 04-10-2026, ronde 2 ("voor web wil ik dat je inspiratie haalt over de animatie van hoe het menu opent en wisselt tussen andere menu's.
  // overloopt en opent ... design wise wil ik onze basis houden maar de manier van navigeren wil ik dat je inspireert uit de html die ik heb
  // meegestuurd"). Naar het voorbeeld (shirt-discounter, ronde 12), in Banky's eigen vorm (zwevende witte kaart, tint, inkt):
  // - aanwijzen met intentie: openen 120 ms na aanwijzen, wisselen naar een ander menu na 40 ms, sluiten 250 ms na weggaan (was 60/180 ms);
  //   kort langs de knoppen strijken opent dus niets, en van paneel naar knop (of terug) gaan sluit niets;
  // - eerste opening: het paneel rolt in 340 ms van boven uit (clip-path), de inhoud komt 8px omhoog in beeld, gestaffeld (30 ms plus hooguit 10 x 14 ms);
  // - wisselen: één doorlopend vlak. De hoogte loopt in 360 ms over van het oude naar het nieuwe paneel, de nieuwe inhoud schuift 22px in vanuit
  //   de looprichting (rechts of links) en een kopie van de oude inhoud fadet in dezelfde richting weg. Nooit een leeg moment of een kale pagina,
  //   dus ook geen Safari-flits (het nieuwe paneel staat in hetzelfde frame open als het oude dichtgaat, zoals sinds 02-10);
  // - sluiten: het paneel rolt in 240 ms omhoog, de afdekking en de pil faden mee;
  // - één pil (tint) glijdt achter de menu-items mee naar het open menu (banky-header-float);
  // - toetsenbord: pijl links en rechts gaan naar het vorige of volgende menu-item (en wisselen mee als er een menu open is), pijl omlaag opent
  //   en zet de focus op de eerste link; Enter, Escape en focus weg blijven van Halo;
  // - prefers-reduced-motion: alles direct, zonder beweging.
  // Alleen opacity, transform, clip-path en height (Web Animations API), geen nieuwe lagen boven de pagina.
  // Ronde 2 def (Geert 04-10-2026, zelfde opdracht; punten uit de toetsen): wisselen naar een ander menu pas als de muis daar 80 ms rustig is
  // (een snelle veeg over de knoppen opent geen tussenpanelen meer); de inhoud komt bij openen per blok in beeld (Bekijk alle, kolom 1 en
  // kaart samen, dan kolom 2 en 3, keuzehulp, voet) in plaats van per regel; bij wisselen houdt de kopie van het oude paneel van de kaart alleen
  // het vlak (geen dubbele foto of prijs) en komt de nieuwe kaartinhoud iets later; geen meting van de kaarthoogte meer bij openen (CSS
  // reserveert de ruimte, menu-style.css); pijl links en rechts lopen door alle menu-items, ook Contact.
  const EASE = 'cubic-bezier(.2,.8,.2,1)';
  const ALLE = () => [...document.querySelectorAll('details.banky-menu-disclosure')];
  // Alle menu-items van de desktopbalk op volgorde: de knop van een megamenu of een gewone link (Contact).
  const ITEMS = () => [...document.querySelectorAll('store-header .header__link-list > ul > li')].map(li => li.querySelector(':scope > details.banky-menu-disclosure > summary, :scope > a')).filter(Boolean);
  const WISSEL = 80;
  const paneelVan = d => d && d.lastElementChild;
  const inhoud = p => [...p.children].filter(c => !c.classList.contains('banky-mega__geest') && c.tagName !== 'TEMPLATE');
  const stopAnims = p => { if (p && p._bankyAnims) { p._bankyAnims.forEach(a => a && a.cancel()); p._bankyAnims = null; } };
  const afdekking = aan => document.querySelector('.shopify-section--header')?.classList.toggle('is-banky-mega-open', aan);
  let wissel = null;
  const pil = () => {
    const w = document.querySelector('store-header.banky-header--float .header__wrapper');
    if (!w) return null;
    let el = w.querySelector(':scope > .banky-nav-pil');
    if (!el) { el = document.createElement('span'); el.className = 'banky-nav-pil'; el.setAttribute('aria-hidden', 'true'); w.prepend(el); }
    return el;
  };
  const zetPil = d => {
    const el = pil();
    if (!el) return;
    const kop = el.closest('store-header');
    // Dicht: de pil fadet weg; de items houden geen eigen tint tot het paneel echt dicht is (pilUit), anders kleurt het item nog even op.
    if (!d) { el.classList.remove('is-zichtbaar'); return; }
    // Ronde 7: de pil staat achter het hele menu-item (naam en knop), even groot als de summary van eerst.
    const s = d.parentElement?.matches('li.banky-nav-item') ? d.parentElement : d.querySelector(':scope > summary'), w = el.parentElement;
    if (!s) return;
    const rs = s.getBoundingClientRect(), rw = w.getBoundingClientRect(), was = el.classList.contains('is-zichtbaar');
    if (!was) el.classList.add('is-direct');
    el.style.width = rs.width + 'px';
    el.style.height = rs.height + 'px';
    el.style.transform = `translate(${rs.left - rw.left - w.clientLeft}px, ${rs.top - rw.top - w.clientTop}px)`;
    if (!was) void el.offsetWidth;
    el.classList.add('is-zichtbaar');
    kop.classList.add('is-banky-pil');
    if (!was) requestAnimationFrame(() => requestAnimationFrame(() => el.classList.remove('is-direct')));
  };
  const pilUit = () => document.querySelector('store-header.banky-header--float')?.classList.remove('is-banky-pil');
  // Kopie van de oude inhoud voor het wegfaden (zelfde klassen, zodat hij er precies zo uitziet; geen links bereikbaar, geen beloftes).
  // Ronde 2 def: de kaart in de kopie houdt de hoogte van de oude kaart; haar inhoud fadet sneller weg (wisselIn), zodat er geen twee foto's of
  // prijzen over elkaar staan.
  const maakGeest = p => {
    const g = document.createElement('div');
    g.className = p.className + ' banky-mega__geest';
    g.setAttribute('aria-hidden', 'true');
    g.inert = true;
    // Geert 05-10-2026, ronde 4 ("op laptop mogen bij opladers en kabels 2 producten in de dropdown mogen laten zien"): elke kaart in de kopie
    // houdt de hoogte van haar eigen kaart (er kunnen er nu twee zijn).
    const hoogtes = [...p.querySelectorAll('.banky-mega__feature')].map(k => k.offsetHeight);
    inhoud(p).forEach(c => g.append(c.cloneNode(true)));
    g.querySelectorAll('.banky-mega__feature').forEach((f, i) => { f.style.height = (hoogtes[i] || 0) + 'px'; });
    g.querySelectorAll('[data-belofte],[id]').forEach(x => { x.removeAttribute('data-belofte'); x.removeAttribute('id'); });
    return g;
  };
  const rolUit = d => {
    const p = paneelVan(d);
    if (!p || rust.matches || !p.animate) return;
    // Per blok (toets ronde 2: per regel stond er op 120 ms alleen kolom 1 in een leeg vlak): Bekijk alle, kolom 1 en de kaart samen, dan de
    // andere kolommen, keuzehulp en voet, telkens 30 ms later. Ronde 5 (05-10-2026): de keuzehulp staat in het lichaam, niet meer direct onder het paneel.
    const kolommen = [...p.querySelectorAll('.banky-mega__groups > *')];
    // Ronde 4 (Geert 05-10-2026): met twee kaarten komen ze samen in beeld (het blok eromheen), niet alleen de eerste.
    const blokken = [[p.querySelector(':scope > .banky-mega__all'), 0], [kolommen[0], 0], [p.querySelector('.banky-mega__nieuw, .banky-mega__kaarten, .banky-mega__feature'), 0]]
      .concat(kolommen.slice(1).map((k, i) => [k, i + 1]), [[p.querySelector('.banky-mega__keuzehulp'), kolommen.length], [p.querySelector(':scope > .banky-mega__foot'), kolommen.length + 1]]);
    p._bankyAnims = [p.animate({clipPath: ['inset(0 -40px 100% -40px)', 'inset(-10px -40px -60px -40px)']}, {duration: 340, easing: EASE})]
      .concat(blokken.filter(([el]) => el).map(([el, i]) => el.animate({opacity: [0, 1], transform: ['translateY(8px)', 'none']}, {duration: 280, delay: 40 + i * 30, easing: EASE, fill: 'backwards'})));
  };
  const wisselIn = (d, w) => {
    const p = paneelVan(d);
    if (!p || rust.matches || !p.animate) { w.geest?.remove(); return; }
    const dir = Math.sign(ALLE().indexOf(d) - w.index) || 1, nieuw = p.offsetHeight;
    p.append(w.geest);
    p.style.overflow = 'hidden';
    // Geert 05-10-2026, ronde 4 (Ss2: "deze usp verspringt na openen licht naar links fix dat"): de voet onderaan (voordelen en voetlinks) staat
    // in alle panelen op dezelfde plek en schuift bij wisselen niet meer mee; alleen zijn tekst fadet over (oud uit, nieuw in). De rest van de
    // inhoud schuift zoals in ronde 2 22px in de looprichting.
    const voet = c => c.classList.contains('banky-mega__foot');
    const anims = [
      w.hoogte !== nieuw && p.animate({height: [w.hoogte + 'px', nieuw + 'px']}, {duration: 360, easing: EASE}),
      w.geest.animate({opacity: [1, 0]}, {duration: 160, easing: 'ease-out', fill: 'forwards'}),
    ];
    [...w.geest.children].filter(c => !voet(c)).forEach(c => anims.push(c.animate({transform: ['none', `translateX(${-22 * dir}px)`]}, {duration: 300, easing: EASE, fill: 'forwards'})));
    inhoud(p).forEach(c => {
      anims.push(c.animate({opacity: [0, 1]}, {duration: 280, delay: 70, easing: 'ease-out', fill: 'backwards'}));
      if (!voet(c)) anims.push(c.animate({transform: [`translateX(${22 * dir}px)`, 'none']}, {duration: 420, easing: EASE}));
    });
    // Ronde 2 def (toets: twee productbeelden en prijzen even over elkaar): de oude kaartinhoud is in 100 ms weg, de nieuwe komt pas na 120 ms.
    w.geest.querySelectorAll('.banky-mega__feature > *').forEach(c => anims.push(c.animate({opacity: [1, 0]}, {duration: 100, easing: 'ease-out', fill: 'forwards'})));
    p.querySelectorAll('.banky-mega__feature > *').forEach(c => anims.push(c.animate({opacity: [0, 1]}, {duration: 220, delay: 120, easing: 'ease-out', fill: 'backwards'})));
    p._bankyAnims = anims.filter(Boolean);
    Promise.all(p._bankyAnims.map(a => a.finished)).catch(() => {}).then(() => { w.geest.remove(); p.style.removeProperty('overflow'); });
  };

  const koppel = root => root.querySelectorAll('details.banky-menu-disclosure').forEach(d => {
    if (d.dataset.bankyKop) return;
    d.dataset.bankyKop = '1';
    let t = null, y = 0, opBrug = false;
    const summary = d.querySelector(':scope > summary'), paneel = paneelVan(d);
    // 2d (Geert 05-10-2026, ronde 7: "deze categorien moeten ook klikbaar zijn op web trouwens"): met een klikbare naam (a.banky-nav-naam,
    // vóór de details) is het vak dat aanwijzen en verlaten meet het hele menu-item (li: naam, knop en paneel), anders de details.
    const li = d.parentElement, naam = li?.matches('li.banky-nav-item') ? li.querySelector(':scope > a.banky-nav-naam') : null, vak = naam ? li : d;
    const muisGebaar = e => muis.matches && e.pointerType !== 'touch' && e.pointerType !== 'pen';
    // Openen (Halo roept dit aan na het zetten van open, ook bij klikken en Enter). Een ander paneel dat net in hetzelfde moment dichtging
    // (wissel) of nog aan het oprollen is, wordt een wissel; anders rolt het paneel uit.
    d._transitionIn = () => {
      afdekking(true);
      let w = wissel && performance.now() - wissel.t < 120 ? wissel : null;
      wissel = null;
      if (!w) {
        const s = ALLE().find(x => x !== d && x._bankyUit);
        if (s) { const ps = paneelVan(s); w = {hoogte: ps.offsetHeight, index: ALLE().indexOf(s), geest: maakGeest(ps)}; stopAnims(ps); }
      }
      stopAnims(paneel);
      if (paneel) { tips(paneel); if (paneel._bankyMeet) paneel._bankyMeet(); }
      zetPil(d);
      if (w) wisselIn(d, w); else rolUit(d);
      return Promise.resolve();
    };
    // Sluiten. Gaat er tegelijk een ander paneel open (wisselen), dan meteen (A's Safari-fix), met de maat en een kopie voor de overloop;
    // anders rolt het paneel eerst op en haalt Halo daarna open weg.
    d._transitionOut = () => {
      const ander = ALLE().find(x => x !== d && x.hasAttribute('open'));
      if (ander || !paneel || rust.matches || !paneel.animate) {
        if (ander && paneel) wissel = {hoogte: paneel.offsetHeight, index: ALLE().indexOf(d), geest: maakGeest(paneel), t: performance.now()};
        stopAnims(paneel);
        if (!ander) { afdekking(false); zetPil(null); pilUit(); }
        return Promise.resolve();
      }
      afdekking(false);
      zetPil(null);
      stopAnims(paneel);
      const anims = [paneel.animate({clipPath: ['inset(-10px -40px -60px -40px)', 'inset(0 -40px 100% -40px)']}, {duration: 240, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards'})]
        .concat(inhoud(paneel).map(c => c.animate({opacity: [1, 0]}, {duration: 140, easing: 'ease-in', fill: 'forwards'})));
      paneel._bankyAnims = anims;
      const klaar = d._bankyUit = Promise.all(anims.map(a => a.finished)).catch(() => {}).then(() => {
        if (d._bankyUit === klaar) d._bankyUit = null;
        queueMicrotask(() => { anims.forEach(a => a.cancel()); if (paneel._bankyAnims === anims) paneel._bankyAnims = null; });
      });
      return klaar;
    };
    // Halo sluit een open paneel zodra de focus erbuiten komt. Een klik of tik op een andere menuknop geeft die knop de focus
    // al bij het indrukken, ruim vóór de klik die het nieuwe paneel opent (Safari: tot ~100 ms kale pagina). Bij zo'n indruk
    // blijft dit paneel open tot de klik; Halo sluit het dan in hetzelfde moment dat het nieuwe opengaat.
    const haloFocus = d._detectFocusOutListener;
    if (typeof haloFocus === 'function') {
      // 2d: focus van de knop of het paneel naar de naam (of terug) blijft binnen het menu-item; het menu blijft dan open.
      const focusUit = e => { if ((!drukOp || e.relatedTarget !== drukOp) && !(naam && e.relatedTarget && li.contains(e.relatedTarget))) haloFocus(e); };
      if (d.hasAttribute('open')) { document.removeEventListener('focusout', haloFocus); document.addEventListener('focusout', focusUit); }
      d._detectFocusOutListener = focusUit;
    }
    // 2d: een klik of tik op de naam is geen klik buiten het menu (Halo sluit het anders in dezelfde klik waarin een tik het opent).
    const haloKlik = d._detectClickOutsideListener;
    if (naam && typeof haloKlik === 'function') {
      const klikUit = e => { if (!li.contains(e.target)) haloKlik(e); };
      if (d.hasAttribute('open')) { document.removeEventListener('click', haloKlik); document.addEventListener('click', klikUit); }
      d._detectClickOutsideListener = klikUit;
    }
    const open = () => {
      if (d.open) return;
      if (d._bankyUit) { d._bankyUit.then(() => { if (!d.open && vak.matches(':hover')) d.open = true; }); return; }
      d.open = true;
    };
    const sluit = () => { clearTimeout(t); t = setTimeout(() => { if (d.open && !vak.querySelector(':focus-visible')) d.open = false; }, 250); };
    // Wisselen (er is al een ander menu open) gaat pas als de muis 80 ms op deze knop is zonder snel verder te bewegen: een veeg over de
    // knoppen naar Alle producten opent onderweg geen Opladers en Kabels meer (toets ronde 2: drie overlopen na elkaar). Ronde 2 def.
    let vorig = null;
    const ander = () => ALLE().some(x => x !== d && (x.open || x._bankyUit));
    vak.addEventListener('pointerenter', e => {
      if (!muisGebaar(e)) return;
      clearTimeout(t);
      opBrug = false;
      if (d.open) return;
      vorig = {x: e.clientX, y: e.clientY, t: e.timeStamp};
      t = setTimeout(open, ander() ? WISSEL : 120);
    });
    const beweeg = e => {
      if (!muisGebaar(e) || d.open || !vorig) return;
      const dt = e.timeStamp - vorig.t, v = dt > 0 ? Math.hypot(e.clientX - vorig.x, e.clientY - vorig.y) / dt : 0;
      vorig = {x: e.clientX, y: e.clientY, t: e.timeStamp};
      if (v > 0.5 && ander()) { clearTimeout(t); t = setTimeout(open, WISSEL); }
    };
    [summary, naam].forEach(x => x?.addEventListener('pointermove', beweeg, {passive: true}));
    vak.addEventListener('pointerleave', e => { if (muisGebaar(e)) sluit(); });
    // Brug: de strook tussen knop en paneel (onderrand van de pil plus 10 px, ~21 px) hoort niet bij het menu en de ::before
    // van het paneel wordt door zijn overflow afgeknipt. Zolang de muis in die strook is, telt de sluitmarge niet; erbuiten
    // weer gewoon 250 ms.
    addEventListener('pointermove', e => {
      if (!d.open || !summary || !paneel || !muisGebaar(e)) return;
      if (vak.contains(e.target)) { opBrug = false; return; }
      const s = (naam ? li : summary).getBoundingClientRect(), p = paneel.getBoundingClientRect();
      const nu = e.clientY >= s.bottom - 1 && e.clientY <= p.top + 1 && e.clientX >= p.left && e.clientX <= p.right;
      if (nu === opBrug) return;
      opBrug = nu;
      if (nu) clearTimeout(t); else sluit();
    }, {passive: true});
    // Muis: een klik op de knop van een open paneel laat het open (Halo's AnimatedDetails zou het weer sluiten). In de
    // vangfase op het details-element, dus vóór Halo's eigen klikluisteraar op de summary.
    d.addEventListener('click', e => {
      if (!summary || !summary.contains(e.target) || !d.open) return;
      if (e.detail > 0 && muis.matches && e.pointerType !== 'touch' && e.pointerType !== 'pen') { e.preventDefault(); e.stopPropagation(); }
    }, true);
    // 2d: op een aanraakscherm (iPad liggend: desktopbreedte zonder aanwijzen) opent de eerste tik op de naam het menu (daarin staat
    // 'Bekijk alle ...'); staat het menu al open, dan volgt de tik de link. Muis, toetsenbord (Enter, detail 0) en ctrl, cmd, shift of alt
    // volgen altijd gewoon de link; de middelklik geeft geen click.
    // Reviewronde r7: alleen een klik die hooguit 1 s na een pointerdown op de naam komt van een vinger of pen (of van een muis zonder
    // echte hover, zoals de trackpad van een iPad) telt als tik. Een klik zonder pointerdown (schermlezer zoals VoiceOver, toetsenbord)
    // volgt altijd de link; het menu blijft voor hen te openen met de eigen knop (het pijltje) of pijl omlaag. pointercancel (wegschuiven,
    // scrollen) wist de tik, zodat een latere klik niet meer als tik telt.
    if (naam) {
      let tik = null;
      naam.addEventListener('pointerdown', e => {
        tik = (e.pointerType === 'touch' || e.pointerType === 'pen' || (e.pointerType === 'mouse' && !muis.matches)) ? e.timeStamp : null;
      }, {passive: true});
      naam.addEventListener('pointercancel', () => { tik = null; }, {passive: true});
      naam.addEventListener('click', e => {
        const aanraak = tik !== null && e.timeStamp - tik < 1000;
        tik = null;
        if (!aanraak || d.open || e.defaultPrevented || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        d.open = true;
      });
    }
    d.addEventListener('toggle', () => {
      y = scrollY;
      if (!d.hasAttribute('open')) { opBrug = false; if (paneel && paneel._bankyTerug) paneel._bankyTerug(); }
      if (!ALLE().some(x => x.hasAttribute('open'))) { afdekking(false); zetPil(null); pilUit(); }
    });
    addEventListener('scroll', () => { if (d.open && Math.abs(scrollY - y) > 80) d.open = false; }, {passive: true});
  });
  // Pijltjestoetsen tussen de menu-items (Geert 04-10-2026, ronde 2, naar het voorbeeld). Eerst het nieuwe menu open (dan is het een wissel),
  // dan de focus erheen.
  // Ronde 2 def (toets: Contact werd overgeslagen): links en rechts lopen door alle items van de balk, ook de gewone link Contact.
  // 2d (ronde 7): de items zijn nu de namen (link) van de categorieën en Contact; pijl links en rechts gaan van naam naar naam, ook vanaf
  // een menuknop. Pijl omlaag op de naam of de knop opent het menu en zet de focus op de eerste link, Escape op de naam sluit het.
  const menuVan = el => el?.closest('li')?.querySelector(':scope > details.banky-menu-disclosure') || null;
  document.addEventListener('keydown', e => {
    const s = e.target.closest?.('details.banky-menu-disclosure > summary, store-header .header__link-list > ul > li > a');
    if (!s || e.altKey || e.ctrlKey || e.metaKey) return;
    const items = ITEMS(), li = s.closest('li'), i = items.findIndex(x => x.closest('li') === li), d = menuVan(s);
    if (i < 0) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      e.preventDefault();
      const n = items[(i + (e.key === 'ArrowRight' ? 1 : items.length - 1)) % items.length], nd = menuVan(n);
      if (nd && ALLE().some(x => x.open) && !nd.open) nd.open = true;
      n.focus();
    } else if (e.key === 'ArrowDown' && d) {
      e.preventDefault();
      if (!d.open) d.open = true;
      setTimeout(() => paneelVan(d)?.querySelector('a[href]')?.focus(), 60);
    } else if (e.key === 'Escape' && d && d.open && !d.contains(s)) {
      d.open = false;
    }
  });
  // Geert 16-10-2026, punt 16 (toets: met de focus op een link in een open paneel sloot Escape het menu, maar de focus viel naar body, dus geen
  // zichtbare focus meer en een schermlezer kwijt waar hij was): Escape in het paneel sluit het menu en zet de focus terug op het item waarmee
  // het geopend werd (de naam of de menuknop, laatst gefocust binnen dat menu-item), anders op de menuknop. In de vangfase, vóór Halo's eigen
  // Escape, die alleen sluit.
  let laatsteKnop = null;
  document.addEventListener('focusin', e => {
    const s = e.target.closest?.('store-header .header__link-list > ul > li > :is(a, details.banky-menu-disclosure > summary)');
    if (s) laatsteKnop = s;
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape' || e.altKey || e.ctrlKey || e.metaKey) return;
    const d = e.target.closest?.('details.banky-menu-disclosure[open]');
    const p = paneelVan(d);
    if (!d || !p || !p.contains(e.target)) return;
    const li = d.closest('li');
    const doel = laatsteKnop && laatsteKnop.isConnected && li && li.contains(laatsteKnop) ? laatsteKnop : d.querySelector(':scope > summary');
    d.open = false;
    if (doel) doel.focus({preventScroll: true});
  }, true);
  // Reviewronde r7 (gevolg van 2d: op een iPad opent de eerste tik op een naam nu het menu, dus wordt er vaker buiten getikt om te sluiten):
  // een tik met vinger of pen buiten de kop terwijl een megamenu open is, sluit alleen het menu en activeert niet de link of knop eronder
  // (de afdekking laat klikken door; met de muis blijft dat zo). In de vangfase op document, vóór Halo's eigen klik-buitenluisteraar, die
  // dan niet meer nodig is.
  // Of er een menu open was, telt op het moment van de pointerdown: Halo kan het bij focus weg al vóór de klik sluiten.
  let tikBuiten = null;
  addEventListener('pointerdown', e => {
    tikBuiten = (e.pointerType === 'touch' || e.pointerType === 'pen') && ALLE().some(x => x.open) ? e.timeStamp : null;
  }, {capture: true, passive: true});
  document.addEventListener('click', e => {
    const tik = tikBuiten !== null && e.timeStamp - tikBuiten < 1000;
    tikBuiten = null;
    if (!tik || e.target.closest?.('store-header')) return;
    e.preventDefault();
    e.stopPropagation();
    ALLE().forEach(x => { if (x.open) x.open = false; });
  }, true);

  // 2c. Uitgelicht product dat meewisselt (Geert 04-10-2026, ronde 2: "check ook hoe het uitgelichtte product wisselt per hoover van categorie
  // op hun web. hier kunnen we ook wat mee. maak voorstel hierop"). Elke link in Powerbanks en Opladers heeft een voorgerenderde kaart in de
  // template van zijn paneel (build_menu.py: per collectielink het eerste beschikbare product uit menu-weergave.json, passend bij de link en
  // daarna op verkoop; bij een productlink dat product zelf). Aanwijzen of focussen van een link zet die kaart in de uitgelichte kaart (foto,
  // titel, detail, prijs en de link van de kaart), met een korte overgang (opacity .25 naar 1 en 6px omhoog, 450 ms, 40 ms na elkaar). Weg
  // uit de kolommen: na 160 ms weer de vaste kaart, tenzij je de kaart zelf aanwijst (dan kun je hem aanklikken). Foto's halen in rustige tijd
  // na de eerste opening; de wissel wacht hooguit 150 ms op een foto. prefers-reduced-motion: zonder overgang. Sluiten: terug naar de vaste kaart.
  // Ronde 2 def (Geert 04-10-2026, zelfde opdracht; punten uit de toetsen):
  // - rust: de kaart wisselt pas als de muis 100 ms op een link blijft (een veeg langs de kolom gaf zes wissels in 300 ms); met het toetsenbord
  //   meteen. Komt er een wissel terwijl de vorige nog loopt, dan alleen een korte fade van 150 ms;
  // - op weg naar de kaart (menu aim): beweegt de muis van de getoonde link naar de kaart en blijft hij in de driehoek van de link naar de
  //   linkerhoeken van de kaart, dan wisselen de links die hij onderweg passeert niet (anders kwam je bij het verkeerde product aan);
  // - is het product van de link gelijk aan wat er al staat, dan gebeurt er niets (geen labelwissel, geen overgang);
  // - het label is een vaste tekst per menu (data-label op de template; Powerbanks 'Meest gekozen powerbank', Opladers 'Meest gekozen door
  //   klanten'), niet meer de linknaam; bij een productlink valt het label weg (ruimte blijft), want dan is de kaart een voorbeeld van dat product;
  // - kaarthoogte: één keer per paneel en per vensterbreedte gemeten, met kopieën van de kaart naast elkaar in één layout (een paar ms), niet
  //   meer bij elke opening per kaart (toets techniek: 40 tot 70 ms per klik, tot 470 ms op een trage CPU).
  function tips(paneel) {
    if (paneel.dataset.bankyTips) return;
    const tpl = paneel.querySelector('template[data-banky-tips]'), kaart = paneel.querySelector('a.banky-mega__feature'), kolommen = paneel.querySelector('.banky-mega__groups');
    if (!tpl || !kaart || !kolommen) return;
    paneel.dataset.bankyTips = '1';
    const RUST = 100;
    const deel = (el, k) => el.querySelector(k);
    const K = ['.banky-mega__image', '.banky-mega__feature-copy', '.banky-menu-price'];
    const labelEl = deel(kaart, '.banky-mega__feature-label');
    const standaard = {id: 'standaard', href: kaart.getAttribute('href'), label: labelEl ? labelEl.textContent : '', delen: K.map(k => deel(kaart, k)?.cloneNode(true))};
    const tipLabel = tpl.hasAttribute('data-label') ? tpl.dataset.label : standaard.label;
    // Reviewronde r7: een link met een eigen keuze van Geert (soort 'keuze', menu-weergave.json 'keuze') krijgt een neutraal label
    // (data-label-keuze, 'Uitgelicht'), want 'Meest gekozen powerbank' klopt daar niet: die keuze is niet op verkoop gemaakt.
    const keuzeLabel = tpl.hasAttribute('data-label-keuze') ? tpl.dataset.labelKeuze : tipLabel;
    let nu = 'standaard', actief = null, kandidaat = null, anker = null, terug = null, wachtT = null, beurt = 0, lopend = [], vorigeWissel = 0;
    const punten = [];
    const wacht = ms => new Promise(r => setTimeout(r, ms));
    const voor = a => {
      const v = tpl.content.querySelector(`[data-voor="${CSS.escape(a.dataset.bankyTip || '')}"]`);
      if (!v) return null;
      const z = v.dataset.zelfde;
      if (z === 'standaard') return standaard;
      const bron = z ? tpl.content.querySelector(`[data-product="${CSS.escape(z)}"]`) : v;
      return bron ? {id: bron.dataset.product, href: bron.dataset.href, bron, label: v.dataset.soort === 'product' ? '' : v.dataset.soort === 'keuze' ? keuzeLabel : tipLabel} : null;
    };
    const zetLabel = doel => { if (labelEl) { labelEl.textContent = doel.label || standaard.label; labelEl.style.visibility = doel.label ? '' : 'hidden'; } };
    const zet = async (doel, animeer) => {
      // Zelfde product: geen overgang; alleen het label kan anders zijn (een keuze tegenover een collectielink met hetzelfde product).
      if (doel.id === nu) { zetLabel(doel); return; }
      nu = doel.id;
      const mijn = ++beurt;
      const nieuw = doel.bron ? K.map(k => { const x = doel.bron.querySelector(k); return x ? document.importNode(x, true) : null; }) : doel.delen.map(x => x && x.cloneNode(true));
      const img = nieuw[0] && nieuw[0].querySelector('img');
      if (img) { img.loading = 'eager'; if (!img.complete) await Promise.race([img.decode().catch(() => {}), wacht(150)]); }
      if (mijn !== beurt) return;
      kaart.setAttribute('href', doel.href);
      zetLabel(doel);
      const oud = K.map(k => deel(kaart, k));
      nieuw.forEach((n, i) => { if (n && oud[i]) oud[i].replaceWith(n); });
      lopend.forEach(x => x.cancel());
      lopend = [];
      if (!animeer || rust.matches) return;
      const kort = performance.now() - vorigeWissel < 450;
      vorigeWissel = performance.now();
      lopend = nieuw.filter(Boolean).map((n, i) => kort ? n.animate({opacity: [.5, 1]}, {duration: 150, easing: 'ease-out'})
        : n.animate([{opacity: .25, transform: 'translateY(6px)'}, {opacity: 1, transform: 'none'}], {duration: 450, delay: i * 40, easing: EASE, fill: 'backwards'}));
    };
    const stil = () => { kandidaat = null; clearTimeout(wachtT); wachtT = null; };
    // Eén hoogte voor alle kaarten van dit paneel (de hoogste), zodat paneel en voet niet verspringen als de kaart wisselt. Kopieën van de kaart
    // met de delen van elke tip (zonder foto-bron, het fotovak heeft een vaste hoogte) in een verborgen doos naast de kaart: één layout.
    let meetBreedte = 0;
    paneel._bankyMeet = () => {
      if (meetBreedte === innerWidth) return;
      meetBreedte = innerWidth;
      kaart.style.removeProperty('min-height');
      const doos = document.createElement('div');
      doos.setAttribute('aria-hidden', 'true');
      doos.inert = true;
      doos.style.cssText = 'position:absolute;left:0;top:0;visibility:hidden;pointer-events:none;width:' + kaart.offsetWidth + 'px';
      const kopie = delen => { const c = kaart.cloneNode(true); c.removeAttribute('href'); if (delen) K.forEach((k, i) => { const o = c.querySelector(k); if (o && delen[i]) o.replaceWith(delen[i]); }); c.querySelectorAll('img').forEach(i => { i.removeAttribute('srcset'); i.removeAttribute('src'); }); return c; };
      const kaarten = [kopie(null)].concat([...tpl.content.querySelectorAll('[data-product]')].map(v => kopie(K.map(k => { const x = v.querySelector(k); return x ? document.importNode(x, true) : null; }))));
      doos.append(...kaarten);
      kaart.parentElement.append(doos);
      const max = Math.max(...kaarten.map(c => c.getBoundingClientRect().height));
      doos.remove();
      if (max) kaart.style.minHeight = Math.ceil(max) + 'px';
    };
    const naarStandaard = animeer => { clearTimeout(terug); actief = null; zet(standaard, animeer); };
    paneel._bankyTerug = () => { beurt++; nu = ''; stil(); naarStandaard(false); };
    const toon = a => {
      clearTimeout(terug);
      const doel = voor(a);
      if (!doel) return;
      actief = a;
      anker = punten[punten.length - 1] || anker;
      zet(doel, true);
    };
    // Ligt punt p in de driehoek a, b, c?
    const binnen = (p, a, b, c) => {
      const z = (p1, p2, p3) => (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);
      const d1 = z(p, a, b), d2 = z(p, b, c), d3 = z(p, c, a);
      return !((d1 < 0 || d2 < 0 || d3 < 0) && (d1 > 0 || d2 > 0 || d3 > 0));
    };
    // Op weg naar de kaart: de muis beweegt (laatste 120 ms) naar de kaart toe en zit in de driehoek van het anker (laatste punt op de getoonde
    // link) naar de dichtstbijzijnde hoeken van de kaart (rechts: linkerhoeken, eronder: bovenhoeken), met 24px marge.
    const opWeg = () => {
      const p = punten[punten.length - 1];
      if (!anker || !p || performance.now() - p.t > 80) return false;
      const q = punten.find(x => p.t - x.t <= 120);
      if (!q || q === p) return false;
      const r = kaart.getBoundingClientRect();
      if (r.left >= anker.x) return p.x - q.x >= 2 && binnen(p, anker, {x: r.left, y: r.top - 24}, {x: r.left, y: r.bottom + 24});
      if (r.top >= anker.y) return p.y - q.y >= 2 && binnen(p, anker, {x: r.left - 24, y: r.top}, {x: r.right + 24, y: r.top});
      return false;
    };
    const beslis = () => {
      wachtT = null;
      const a = kandidaat;
      if (!a || !a.isConnected || a === actief) return;
      if (opWeg()) { wachtT = setTimeout(beslis, RUST); return; }
      kandidaat = null;
      if (a.matches(':hover')) toon(a);
    };
    const laterTerug = () => { clearTimeout(terug); terug = setTimeout(() => naarStandaard(true), 160); };
    kolommen.addEventListener('pointermove', e => {
      if (e.pointerType === 'touch') return;
      const pt = {x: e.clientX, y: e.clientY, t: e.timeStamp};
      punten.push(pt);
      while (punten.length > 1 && pt.t - punten[0].t > 200) punten.shift();
      if (actief && actief.contains(e.target)) anker = pt;
    }, {passive: true});
    kolommen.addEventListener('pointerover', e => {
      if (!muis.matches || e.pointerType === 'touch') return;
      clearTimeout(terug);
      const a = e.target.closest?.('a[data-banky-tip]');
      if (!a || a === kandidaat) return;
      if (a === actief) { stil(); return; }
      kandidaat = a;
      clearTimeout(wachtT);
      wachtT = setTimeout(beslis, RUST);
    });
    kolommen.addEventListener('pointerleave', e => { if (e.pointerType === 'touch') return; stil(); laterTerug(); });
    kolommen.addEventListener('focusin', e => { const a = e.target.closest?.('a[data-banky-tip]'); if (a) { stil(); toon(a); } });
    kolommen.addEventListener('focusout', e => { if (!e.relatedTarget || (!kolommen.contains(e.relatedTarget) && e.relatedTarget !== kaart)) laterTerug(); });
    kaart.addEventListener('pointerenter', () => { clearTimeout(terug); stil(); });
    kaart.addEventListener('pointerleave', laterTerug);
    kaart.addEventListener('focusout', e => { if (!e.relatedTarget || !kolommen.contains(e.relatedTarget)) laterTerug(); });
    // Foto's van de kaarten in rustige tijd alvast ophalen (zelfde srcset en sizes, dus hetzelfde bestand als straks).
    const haal = () => tpl.content.querySelectorAll('.banky-mega__image img').forEach(i => { const x = new Image(); x.sizes = i.getAttribute('sizes') || ''; if (i.getAttribute('srcset')) x.srcset = i.getAttribute('srcset'); x.src = i.getAttribute('src'); });
    'requestIdleCallback' in window ? requestIdleCallback(haal, {timeout: 1200}) : setTimeout(haal, 300);
  }

  // 2b: welke beloftes staan in de voet van het open menu; de balk staat zolang stil op een vak dat ze niet herhaalt.
  /* Geert 04-10-2026, ronde 3 ("op die plek gaan we nu de sterkste usp van het betreffende menu plaatsen"): in de lade telt alleen de USP links
     onderin van het paneel dat nu open is (banky-header-mobiel-voet, data-menu en data-belofte); een subpaneel dat al terugschuift
     (is-sluitend) telt niet meer. Zo slaat de balk alleen die ene belofte over en wisselt hij verder door. Zonder die voet (oude opbouw):
     alle beloftes in de lade, zoals eerst. */
  const ladeBeloftes = lade => {
    const punten = lade.querySelectorAll('.banky-menu-voet__punt');
    if (!punten.length) return [...lade.querySelectorAll('[data-belofte]')].map(x => x.dataset.belofte);
    const sub = lade.querySelector('.banky-mobile-category[open]:not(.is-sluitend) > .banky-mega--mobile');
    const naam = sub ? ([...sub.classList].find(c => c.startsWith('banky-mega--') && c !== 'banky-mega--mobile') || '').slice(12) : 'hoofdmenu';
    const punt = [...punten].find(x => x.dataset.menu === naam);
    return punt && punt.dataset.belofte ? [punt.dataset.belofte] : [];
  };
  const menuStand = () => {
    const balk = document.querySelector('banky-balk');
    if (!balk || !balk.menuOpen) return;
    const open = [...document.querySelectorAll('details.banky-menu-disclosure[open], #header-sidebar-menu[open]')];
    if (!open.length) { balk.menuDicht(); return; }
    balk.menuOpen(new Set(open.flatMap(m => m.id === 'header-sidebar-menu' ? ladeBeloftes(m) : [...m.querySelectorAll('[data-belofte]')].map(x => x.dataset.belofte))));
  };
  // toggle van details bubbelt niet, die van Halo's lade wel: in de vangfase komen ze allebei langs. Ronde 3: ook het openen en sluiten van
  // een subpaneel in de lade (details.banky-mobile-category), en Terug meteen bij de tik (banky-sales.js zet dan is-sluitend; de details
  // gaan pas dicht als het paneel weg is).
  document.addEventListener('toggle', e => { if (e.target.matches?.('details.banky-menu-disclosure, #header-sidebar-menu, #header-sidebar-menu details.banky-mobile-category')) menuStand(); }, true);
  document.addEventListener('click', e => { if (e.target.closest?.('#header-sidebar-menu .banky-mobile-back')) menuStand(); });

  document.addEventListener('cart:change', () => {
    if (rust.matches) return;
    document.querySelectorAll('.banky-header--float .header__cart-count cart-count').forEach(b => {
      b.classList.remove('banky-kop-puls');
      void b.offsetWidth;
      b.classList.add('banky-kop-puls');
      setTimeout(() => b.classList.remove('banky-kop-puls'), 600);
    });
  });

  // 4. Kop weg en terug bij scrollen (Geert 02-10-2026 op zijn iPhone: "iets soepeler terugkomen, 0.5 vertraging ofzo, minder spastisch").
  // Halo's store-header schoof de kop bij elke pixel omhoog terug in 200 ms en begon elke animatie op een vast beginpunt (een omkering
  // halverwege sprong tot 55px); terugveren onderaan de pagina telde als omhoog. Dit blok neemt het wisselen over: weg na netto 100px
  // omlaag (hide-on-scroll, zoals Halo), terug na netto 20px omhoog (een terugstapje van 1px bij langzaam slepen zet de teller niet op
  // nul), altijd in beeld zolang de kop nog niet vast staat (bovenaan, onder de balk) en dan snel (is-banky-snel, 200 ms), zodat de pil
  // niet over de balk schuift. Terugveren boven en onder telt niet (scrollY geklemd), een stap waarin innerHeight veranderde (Safari-werkbalk
  // klapt in of uit) ook niet. Focus in de kop haalt hem terug. De beweging is een CSS-overgang op store-header zelf (banky-header-float):
  // die staat in getAnimations(), zodat de balken van banky-facets, banky-compare en banky-product per frame meelopen.
  // prefers-reduced-motion: de kop blijft staan.
  // Geert 05-10-2026, ronde 4, punt 3 ("ik als ik nu naar beneden scroll en iets omhoog verschijnt het menu niet en als ik iets naar beneden
  // scroll maar de aankondiging nog net zie versprint ie naar onder dat is niet logisch"): tot en met 1149px zijn aankondigingsbalk en kop één
  // blok (CSS in banky-header-float): de balksectie krijgt dezelfde klassen als de kop en beweegt dus mee, en 'nog niet vast' bestaat daar niet
  // meer (de kop plakt vanaf het begin onder de balk). Terug na netto 8px omhoog (was 20) en een stap waarin innerHeight verandert telt nu wel
  // mee: op een iPhone klapt de Safari-werkbalk juist uit bij het begin van omhoog scrollen, zodat die eerste pixels eerst wegvielen en de kop
  // pas na circa 60px terugkwam. Focus in de balk haalt het blok ook terug. Vanaf 1150px blijft het zoals hierboven, met dezelfde drempel.
  const kopWissel = () => {
    const kop = document.querySelector('store-header.banky-header--float[hide-on-scroll]');
    if (!kop || kop.dataset.bankyWissel) return;
    kop.dataset.bankyWissel = '1';
    kop.hide = kop.show = () => {};   // Halo's scrollluisteraar roept deze aan; het wisselen gebeurt hieronder
    // Laadsnelheid (Geert 04-10-2026): Halo's animaties pas in het volgende beeldje stoppen; getAnimations() dwong tijdens het
    // opstarten een stijlronde over de hele pagina af.
    requestAnimationFrame(() => { kop.getAnimations?.().forEach(a => a.cancel()); kop.style.removeProperty('transform'); });
    const sectie = kop.closest('.shopify-section') || kop.parentElement;
    const weg = parseInt(kop.getAttribute('hide-on-scroll'), 10) || 100, terug = 8;
    const blok = matchMedia('screen and (max-width: 1149px)');
    const balkSectie = () => document.querySelector('.shopify-section--announcement-bar');
    const einde = () => Math.max(0, document.documentElement.scrollHeight - innerHeight);
    const klem = () => Math.min(Math.max(scrollY, 0), einde());
    // De kop staat nog niet vast zolang zijn sectie (sticky, top 0) onder de bovenrand staat: dan hoort hij gewoon in beeld.
    const nietVast = () => !blok.matches && sectie.getBoundingClientRect().top > 0.5;
    // Een lopende terugkomst (500 ms; tot en met 1149px 600 ms, ronde 4 def 05-10-2026) in hoogstens 200 ms afmaken, bijvoorbeeld na een tik op
    // de statusbalk; ronde 4: kop en balk samen.
    const versnel = () => [kop, blok.matches && balkSectie()].filter(Boolean).forEach(el => el.getAnimations?.().forEach(a => {
      if (a.transitionProperty !== 'transform' || a.playState !== 'running' || !a.effect) return;
      const r = a.playbackRate || 1, rest = (a.effect.getComputedTiming().endTime - (a.currentTime || 0)) / r;
      if (rest > 200) a.updatePlaybackRate ? a.updatePlaybackRate(r * rest / 200) : (a.playbackRate = r * rest / 200);
    }));
    // Ronde 4: de balksectie volgt de kop, alleen tot en met 1149px (daarboven staat de balk gewoon in de pagina).
    const balkVolgt = () => {
      const b = balkSectie();
      if (!b) return;
      b.classList.toggle('is-banky-snel', blok.matches && kop.classList.contains('is-banky-snel'));
      b.classList.toggle('is-banky-weg', blok.matches && kop.classList.contains('is-banky-weg'));
    };
    // Ronde 4 def (Geert 05-10-2026, punt 3: "als ik nu naar beneden scroll en iets omhoog verschijnt het menu niet"; toets: wie vlak na het
    // omhoog scrollen op de menuknop tikt terwijl het blok nog terugkomt, tikte door naar de pagina, op collecties zelfs op Filteren). Zolang
    // het blok terugkomt (tot en met 1149px), vangt de rustplek van de kop (height-observer, schuift niet mee) een tik op en geeft hem door
    // aan de knop of link die daar zo meteen staat (menu, logo, zoeken, mand); staat daar niets, dan gaat de tik naar wat eronder ligt.
    const rustplek = kop.parentElement && kop.parentElement.tagName === 'HEIGHT-OBSERVER' ? kop.parentElement : null;
    let vangT = null;
    const vangTerug = ms => {
      if (!rustplek || !blok.matches) return;
      sectie.classList.add('is-banky-terug');
      clearTimeout(vangT);
      vangT = setTimeout(() => sectie.classList.remove('is-banky-terug'), ms + 80);
    };
    rustplek?.addEventListener('click', e => {
      if (e.target !== rustplek || !sectie.classList.contains('is-banky-terug')) return;
      let ty = 0;
      try { ty = new DOMMatrixReadOnly(getComputedStyle(kop).transform).m42 || 0; } catch (x) {}
      const doel = [...kop.querySelectorAll('a[href], button')].find(el => {
        const r = el.getBoundingClientRect();
        return r.width > 0 && getComputedStyle(el).visibility !== 'hidden' && e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top - ty && e.clientY <= r.bottom - ty;
      });
      e.preventDefault();
      e.stopPropagation();
      sectie.classList.remove('is-banky-terug');
      const onder = doel || document.elementFromPoint(e.clientX, e.clientY);
      if (onder && onder !== rustplek) onder.click();
    });
    // Laadsnelheid (Geert 04-10-2026): scrollpositie en vensterhoogte pas bij de eerste scroll lezen; scrollY, scrollHeight en
    // innerHeight dwongen bij het laden (mobiel) een layoutronde af. Die eerste gebeurtenis telt daardoor niet als stap.
    let vorige = null, hoogte = null, omlaag = 0, omhoog = 0;
    const zet = (uit, snel) => {
      omlaag = omhoog = 0;
      if (kop.classList.contains('is-banky-weg') === uit) { if (snel) versnel(); return; }
      kop.classList.toggle('is-banky-snel', !!snel);
      kop.classList.toggle('is-banky-weg', uit);
      balkVolgt();
      if (uit) { clearTimeout(vangT); sectie.classList.remove('is-banky-terug'); } else vangTerug(snel ? 200 : 600);
    };
    addEventListener('scroll', () => {
      if (!kop.isConnected) return;
      const y = klem(), stap = vorige === null ? 0 : y - vorige;
      vorige = y;
      // Geert 04-10-2026, ronde 2 (kop op exact dezelfde plek bij open menu): zolang de lade open is, staat de kop stil.
      if (document.body.classList.contains('banky-menu-open')) { omlaag = omhoog = 0; return; }
      // Ronde 4 (Geert 05-10-2026, punt 3): een stap met een andere innerHeight (Safari-werkbalk) telt mee; de klemming hierboven vangt het
      // terugveren boven en onder op.
      if (innerHeight !== hoogte) hoogte = innerHeight;
      if (rust.matches) { zet(false); return; }
      if (y <= 0 || nietVast()) { zet(false, true); return; }
      if (!stap) return;
      if (kop.classList.contains('is-banky-weg')) {
        omhoog = Math.max(0, omhoog - stap);
        if (omhoog > terug) zet(false);
      } else {
        omlaag = Math.max(0, omlaag + stap);
        if (omlaag > weg) zet(true);
      }
    }, {passive: true});
    kop.addEventListener('focusin', () => zet(false));
    // Ronde 4: focus in de balk (zijn link) haalt het blok ook terug; bij een wissel van breedte over 1149px de balk gelijktrekken; na
    // terugkomen uit de bfcache (terugknop) opnieuw beginnen bij de huidige scrollpositie.
    balkSectie()?.addEventListener('focusin', () => { if (blok.matches) zet(false); });
    blok.addEventListener('change', balkVolgt);
    addEventListener('pageshow', e => { if (e.persisted) { vorige = klem(); hoogte = innerHeight; omlaag = omhoog = 0; balkVolgt(); } });
  };

  // 5. Mobiele kop (Geert 04-10-2026, ronde 2: "met links menu, midden logo, rechts zoek en mand ... als menu geopend is op exact zelfde plek
  // kruisje - logo - zoek - winkelmand"). De opbouw is CSS (banky-header-float); hier alleen wat CSS niet kan:
  // a. tabvolgorde gelijk aan het beeld: Halo's linker menuknop (in .header__icon-list van main-nav) komt in de DOM vóór het mobiele logo;
  //    op desktop is dat logo verborgen, dus daar verandert niets;
  // b. de toegankelijke naam van de menuknop volgt de stand: open heet hij zoals Halo's kruis in de lade ("Sluiten", general.accessibility.close,
  //    bestaande vertaling), dicht weer Halo's eigen tekst; aria-expanded zet Halo zelf;
  // c. zoeken en winkelwagen in de kop werken ook met open lade: eerst gaat de lade dicht (200 ms), dan opent het zoekpaneel of de winkelwagen.
  //    Zonder dit zou Halo's focus-trap de tik op een telefoon opeten (de lade ging dan dicht en pas een tweede tik opende het paneel).
  const mobieleKop = () => {
    const kop = document.querySelector('store-header.banky-header--float');
    if (!kop || kop.dataset.bankyMobiel) return;
    kop.dataset.bankyMobiel = '1';
    const nav = kop.querySelector('.header__main-nav'), lijst = nav && nav.querySelector(':scope > .header__icon-list');
    if (lijst && nav.firstElementChild !== lijst) nav.prepend(lijst);
  };
  const ladeNaam = () => {
    const lade = document.getElementById('header-sidebar-menu');
    if (!lade) return;
    const sluit = lade.querySelector(':scope > [is="close-button"]')?.getAttribute('aria-label') || '';
    document.querySelectorAll('store-header [aria-controls="header-sidebar-menu"]').forEach(k => {
      if (lade.hasAttribute('open') && sluit) k.setAttribute('aria-label', sluit); else k.removeAttribute('aria-label');
    });
  };
  document.addEventListener('toggle', e => { if (e.target && e.target.id === 'header-sidebar-menu') ladeNaam(); }, true);
  document.addEventListener('click', e => {
    const knop = e.target.closest?.('store-header [aria-controls="search-drawer"], store-header [aria-controls="cart-drawer"]');
    const lade = document.getElementById('header-sidebar-menu');
    if (!knop || !lade || !lade.hasAttribute('open') || typeof lade.hide !== 'function') return;
    const doel = document.getElementById(knop.getAttribute('aria-controls'));
    if (!doel || typeof doel.show !== 'function') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    Promise.resolve(lade.hide()).then(() => doel.show());
  }, true);
  //    WP r1-eind.1 (punt 24): WhatsApp in de ladevoet (data-banky-chat-open) opent hetzelfde chatvenster als de zwevende knop. Dat venster
  //    is verborgen zolang een lade de pagina afsluit (html.lock), dus eerst de lade dicht en daarna dezelfde klik opnieuw; die opent het
  //    venster via banky-chat.liquid (focus op "Open WhatsApp-chat"). Pas in de volgende taak: Halo's focus-trap zet na het sluiten de focus
  //    terug op de menuknop (in een microtaak na dialog:after-hide), anders kwam de focus daar in plaats van in het venster. Zonder chatknop op
  //    de pagina gaat de link gewoon naar wa.me.
  document.addEventListener('click', e => {
    const knop = e.target.closest?.('#header-sidebar-menu [data-banky-chat-open]');
    const lade = document.getElementById('header-sidebar-menu');
    if (!knop || !lade || !lade.hasAttribute('open') || typeof lade.hide !== 'function' || !document.querySelector('[data-banky-chat]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    Promise.resolve(lade.hide()).then(() => setTimeout(() => knop.click(), 0));
  }, true);
  // d. Geert 16-10-2026, punt 16 (toets: met het toetsenbord sloot Escape in een subpaneel, zoals Powerbanks, meteen de hele lade): Escape
  //    in een open subpaneel gaat eerst één stap terug, via de Terug-knop van banky-sales.js (zelfde beweging; de focus gaat daarna naar
  //    de categorie in de hoofdlijst). Een tweede Escape sluit de lade zoals voorheen. Op window in de vangfase, vóór de focus-trap van
  //    Halo (die luistert op document en zou de lade sluiten).
  addEventListener('keydown', e => {
    if (e.key !== 'Escape' || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
    const lade = document.getElementById('header-sidebar-menu');
    if (!lade || !lade.hasAttribute('open')) return;
    const sub = lade.querySelector('.banky-mobile-category[open]:not(.is-sluitend)');
    const terugKnop = sub && sub.querySelector('.banky-mobile-back');
    if (!terugKnop) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    terugKnop.click();
  }, true);

  const start = () => { koppel(document); kopWissel(); mobieleKop(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
  document.addEventListener('shopify:section:load', start);
})();
